import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {__} from "~/ts/library/Translate";
import OperatorApplicationDialogTextareaButton
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaButton.vue";
import useTextareaComponent from "~/operatorApplication/vue/dialogs/dialog/textarea/useTextareaComponent";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "UploadButton"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let {showFreeDialogForSite, uploadOnChange, uploadAction, isFree} = useTextareaComponent();

return (_ctx: any,_cache: any) => {
  const _directive_on_native = _resolveDirective("on-native")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(isFree) ? 'span' : 'el-upload'), {
    class: "d-inline-block",
    action: _unref(uploadAction),
    multiple: "",
    "on-change": _unref(uploadOnChange),
    "show-file-list": false
  }, {
    default: _withCtx(() => [
      _withDirectives(_createVNode(OperatorApplicationDialogTextareaButton, {
        icon: "paperclip",
        tooltip: _unref(__)('Прикрепить файл')
      }, null, 8, ["tooltip"]), [
        [_directive_on_native, () => { if (_unref(isFree)) { _unref(showFreeDialogForSite)(); } }, "click"]
      ])
    ]),
    _: 1
  }, 40, ["action", "on-change"]))
}
}

})